import React from 'react'
import styled from 'styled-components'
import css from '@styled-system/css'
import { Container, Flex, P } from 'ui/acro'
import { H1, H3 } from 'ui/bend'
import LotusEllipse from './LotusEllipse'

const NotFoundLink = styled(P)`
  ${css({
    fontFamily: 'Arquitecta',
    textTransform: 'uppercase',
    borderBottom: '1.5px solid black',
    width: 'fit-content',
    fontWeight: '400'
  })}
`

const NotFoundPage = () => {
  return (
    <Container>
      <Flex
        textAlign='center'
        flexDirection='column'
        margin={('45px 0', '60px 0')}
        style={{ gap: '25px' }}
      >
        <Flex
          flexDirection='column'
          alignItems='center'
          style={{ gap: '15px' }}
        >
          <LotusEllipse />
          <H3 textTransform='uppercase'>Nonexistent Page</H3>
          <H1>This Page Took A Wrong Turn</H1>
        </Flex>
        <P>
          Looks like this page doesn't exist.
          <br></br>
          Perhaps one of the links below is what you were looking for.
        </P>
        <Flex
          alignItems='center'
          flexDirection='column'
          style={{ gap: '10px' }}
        >
          <a href='/support'>
            <NotFoundLink>FAQ</NotFoundLink>
          </a>
          <a href='/contact-us'>
            <NotFoundLink>Contact Us</NotFoundLink>
          </a>
          <a href='/'>
            <NotFoundLink>Home</NotFoundLink>
          </a>
          <a href='/class-finder'>
            <NotFoundLink>Classes</NotFoundLink>
          </a>
        </Flex>
      </Flex>
    </Container>
  )
}

export default NotFoundPage
